export function formatDate(date) {
    var newDate = new Date(date);
    var month = newDate.getMonth();
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var day = newDate.getDate();
    return `${months[Number(month)]} ${day}`;

}